import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { EngagementReward } from './EngagementReward';
import { EngagementRewardVersion } from './EngagementRewardVersion';
import { EngagementRewardDeleteResponse } from './EngagementRewardDeleteResponse';
import { EngagementRewardGapResponse } from './EngagementRewardGapResponse';

export default class EngagementRewardResource extends FBaseService {
  public async getAll(fiId: string): Promise<EngagementReward[]> {
    const url = `/api/rcx/config/${fiId}/engagement-rewards`;

    let allVersions: EngagementRewardVersion[] = [];
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      allVersions = response.data.data;
    } catch (error) {
      // Will 404 if fi not set up yet, so just return an empty array
      if (error.response.status !== 404) {
        throw error;
      } else {
        return [];
      }
    }

    const rewardMap: Map<number, EngagementReward> = new Map<number, EngagementReward>();

    allVersions.forEach((version: EngagementRewardVersion) => {
      let reward: EngagementReward | null = null;
      if (!rewardMap.has(version.id!)) {
        reward = new EngagementReward(fiId, version.id!);
        rewardMap.set(version.id!, reward);
      } else {
        reward = rewardMap.get(version.id!)!;
      }

      reward.versions.push(version);
    });

    return Array.from(rewardMap.values());
  }

  public async save(fiId: string, rewardVersion: EngagementRewardVersion): Promise<EngagementRewardVersion> {
    const url = `/api/rcx/config/${fiId}/engagement-rewards`;
    const response: AxiosResponse = await this.apiClient.put(url, rewardVersion);
    return response.data.data;
  }

  public async delete(fiId: string, rewardId: number, designStartDate: string): Promise<EngagementRewardDeleteResponse> {
    const url = `/api/rcx/config/${fiId}/engagement-rewards/${rewardId}/${designStartDate}`;
    const response: AxiosResponse = await this.apiClient.delete(url);
    return response.data.data;
  }

  public async getVersionGap(fiId: string, rewardId: number, designStartDate: string): Promise<EngagementRewardGapResponse> {
    const url = `/api/rcx/config/${fiId}/engagement-rewards/find-version-gap-period/${rewardId}/${designStartDate}`;
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }
}
